export default __webpack_public_path__ + "static/media/29_rocket_man.2d61e555.png";